import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import Cookies from "js-cookie";
import { dashboardZone, zoneWidgets } from "../../../api";
import {
  setDashboardZone,
  setDashboardDetails,
  setZoneWidgets,
} from "../../../redux";
import { Scenarios } from "../Scenarios";
import { UserInfo } from "../UserInfo";
import { Notification } from "../Notification";
import { Widget } from "../../../shared";
import { Row, Col } from "reactstrap";
import { ModalComp, Add } from "../../../shared";
import { Options } from "./Options";
import { withRouter } from "react-router-dom";
import { FiClock } from "react-icons/fi";
import { AutoOrSen } from "../AutoOrsen";
import { useTranslation } from "react-i18next";

const MainPageDesktopComp = (props) => {
  const { t } = useTranslation();
  const { today } = props;
  const dispatch = useDispatch();
  const token = Cookies.get("token");
  const dashboardMine = useSelector(
    (state) => state.dashboardMine.dashboardMine
  );
  const [showDashboard, setShowDashboard] = useState(false);
  const openDash = (value) => setShowDashboard(value);
  const [openModal, setOpenModal] = useState(false);
  const toggle = () => setOpenModal(!openModal);
  const [showOptions, setShowOptions] = useState(false);
  const toggleOptions = () => setShowOptions(!showOptions);
  let [activeIndex, setActiveIndex] = useState(0);
  const getGreetingTime = () => {
    const currentHour = new Date().getHours();
    if (currentHour < 12) {
      return t("صبح بخیر");
    } else if (currentHour < 18 && currentHour >= 12) {
      return t("عصر بخیر");
    } else {
      return t("شب بخیر");
    }
  };
  const [isShow, setIsShow] = useState(true);
  const showScenarios = () => {
    setIsShow(!isShow);
  };
  const dashboardDetail = (value, index) => {
    setActiveIndex(index);
    const formData = new FormData();
    formData.append("dashboard", value.id);
    dashboardZone(formData, token)
      .then((res) => {
        dispatch(setDashboardDetails(value));
        dispatch(setDashboardZone(res.data.data));
        const zoneId = new FormData();
        zoneId.append("zone", res.data.data[0]["id"]);
        zoneWidgets(zoneId, token)
          .then((res) => {
            dispatch(setZoneWidgets(res.data.data));
          })
          .catch(() => {
            dispatch(setZoneWidgets([]));
          });
      })
      .catch((err) => {
        if (err.response.status === 403) {
          Cookies.remove("token");
          props.history.push("/login");
        }
      });
  };

  return (
    <React.Fragment>
      <ModalComp modal={openModal} toggle={toggle} component={<Add />} />
      <div className="desktopElements p-2">
        <Row className="align-items-center userNotif">
          <Col>
            <UserInfo />
          </Col>
          <Col>
            <Notification
              openDash={openDash}
              toggleOptions={toggleOptions}
              showOptions={showOptions}
            />
          </Col>
          <Col>
            <div className="d-flex align-items-center ">
              <span className="d-flex align-items-center justify-content-center gap-2 xl:gap-3 md:gap-1 securityBtn btn-primary w-100 px-1 py-1">
                <i
                  className="icon-security py-1  "
                  style={{ fontSize: "16px" }}
                ></i>
                {t("سیستم امنیتی فعال")}
              </span>
            </div>
          </Col>
        </Row>

        {showDashboard && (
          <Row className="mt-3">
            <Col>
              {/* <div className="dashboard position-relative d-flex align-items-center"></div> */}
              <div className="dashboardElm dashboard d-flex flex-wrap py-3 px-2 ">
                {dashboardMine?.map((dash, index) => {
                  const active = activeIndex === index ? true : false;
                  return (
                    <span
                      className={`dashbordBtn cursor d-block fn ${
                        active ? "bgWhite" : "bgBlur text-white"
                      } 
                                    mb-2 ml-2 mx-1 text-center`}
                      key={index}
                      onClick={() => dashboardDetail(dash, index)}
                    >
                      {dash.dashboard_caption}
                    </span>
                  );
                })}
                <span
                  className="dashbordIcon mx-3 text-center text-white cursor icon-combined-shape"
                  style={{ fontSize: "18px" }}
                  onClick={toggle}
                ></span>
              </div>
            </Col>
          </Row>
        )}
        {!showOptions ? (
          <>
            <Row className="verifywidget mt-5 mb-1 d-flex align-items-baseline ">
              <Col>
                {/* <div className="mt-4 mb-3 d-flex verifywidget"> */}
                <div className="d-flex  ">
                  <Widget today={today} />
                </div>
                {/* </div> */}
              </Col>
              <Col>
                <div className=" d-flex text-right gap-2 align-items-baseline justify-content-end">
                  <p style={{ fontSize: "14px" }}>{getGreetingTime()} </p>
                  <i className=" text-bolder  text-white  px-2 pb-2  rounded-3 bg-blue-opacity  ">
                    <FiClock />
                  </i>
                </div>
              </Col>
            </Row>
            <Row className="scenSection">
              <Col className="scenSection">
                <div className="px-3 py-2 scenarios">
                  {isShow ? <AutoOrSen /> : <></>}
                </div>
              </Col>
            </Row>
          </>
        ) : (
          <Options toggleOptions={toggleOptions} toggle={toggle} />
        )}
        <div className="pLine" onClick={showScenarios}>
          <div className="line"></div>
        </div>
      </div>
    </React.Fragment>
  );
};

const MainPageDesktop = withRouter(MainPageDesktopComp);

export { MainPageDesktop };
